import { Component, HostListener, input, output, inject, computed } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { ThemeService } from '../../core/services/theme.service';
import { NotificationService } from '../../core/services/notification.service';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss',
})
export class TopbarComponent {
  sidebarCollapsed = input<boolean>(false);
  toggleSidebar = output<void>();

  private router = inject(Router);
  private auth = inject(AuthService);
  themeService = inject(ThemeService);
  notifService = inject(NotificationService);

  showNotifications = false;
  showSearch = false;
  showProfileMenu = false;

  /** Derived from the authenticated session; falls back to placeholders if absent. */
  user = computed(() => {
    const session = this.auth.session();
    const name = session?.name || 'User';
    return {
      name,
      role: session?.role || '',
      email: session?.email || '',
      initials: this.initialsFrom(name),
    };
  });

  private initialsFrom(name: string): string {
    const parts = name.trim().split(/[\s._-]+/).filter(Boolean);
    if (parts.length === 0) return 'U';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }

  toggleProfileMenu(event: MouseEvent): void {
    event.stopPropagation();
    this.showProfileMenu = !this.showProfileMenu;
  }

  onMenuAction(action: 'profile' | 'security' | 'preferences' | 'logout'): void {
    this.showProfileMenu = false;
    if (action === 'logout') {
      this.auth.logout();
      this.notifService.info('Signed out', 'You have been logged out.');
      this.router.navigateByUrl('/login');
      return;
    }

    const label = action === 'profile'
      ? 'Profile'
      : action === 'security'
      ? 'Security'
      : 'Preferences';
    this.notifService.info(`${label} is coming soon`);
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    this.showProfileMenu = false;
  }
}
